import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AC, Field, FormCard, ListState, Pick, post, useList, useMembersByRole, useSubmit } from "./shared";
import { api } from "@/lib/api";

const HARI = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];

export const ScheduleTab = ({ canManage }) => {
  const [kelas, setKelas] = useState("semua");
  const q = useList(`${AC}/schedule${kelas !== "semua" ? `?class_id=${kelas}` : ""}`);
  const classes = useList(`${AC}/classes`);
  const subjects = useList(`${AC}/subjects`);
  const teachers = useMembersByRole(["guru", "wali_kelas"]);
  const s = useSubmit();
  const del = useSubmit();
  const [f, setF] = useState({ class_id: "", subject_id: "", teacher_membership_id: "", day_of_week: "Senin",
                               start_time: "07:00", end_time: "07:45", room: "" });

  const add = () => s.run(
    () => post("/schedule", { ...f, room: f.room.trim() || undefined }),
    "Slot jadwal disimpan.",
  ).then((ok) => ok && setF({ ...f, class_id: "", subject_id: "", teacher_membership_id: "", room: "" }));

  const hapus = (slot) => {
    if (!window.confirm(`Hapus jadwal ${slot.subject_name} di ${slot.class_name} (${slot.day_of_week} ${slot.start_time}-${slot.end_time})?`)) return;
    del.run(() => api.delete(`${AC}/schedule/${slot.id}`), "Jadwal dihapus.");
  };

  return (
    <div className="space-y-5">
      {canManage && (
        <FormCard title="Tambah slot jadwal" onSubmit={add} busy={s.busy} err={s.err} submitLabel="Simpan jadwal" testId="schedule-form">
          <Pick label="Kelas" value={f.class_id} onChange={(v) => setF({ ...f, class_id: v })}
            options={(classes.data || []).map((k) => ({ value: k.id, label: k.name }))} testId="schedule-class-select" />
          <Pick label="Mata pelajaran" value={f.subject_id} onChange={(v) => setF({ ...f, subject_id: v })}
            options={(subjects.data || []).map((x) => ({ value: x.id, label: x.name }))} testId="schedule-subject-select" />
          <Pick label="Guru" value={f.teacher_membership_id} onChange={(v) => setF({ ...f, teacher_membership_id: v })}
            options={teachers.map((t) => ({ value: t.id, label: t.full_name }))} testId="schedule-teacher-select" />
          <Pick label="Hari" value={f.day_of_week} onChange={(v) => setF({ ...f, day_of_week: v })}
            options={HARI.map((h) => ({ value: h, label: h }))} testId="schedule-day-select" />
          <Field id="sch-start" label="Jam mulai" type="time" value={f.start_time} onChange={(e) => setF({ ...f, start_time: e.target.value })} data-testid="schedule-start-input" />
          <Field id="sch-end" label="Jam selesai" type="time" value={f.end_time} onChange={(e) => setF({ ...f, end_time: e.target.value })} data-testid="schedule-end-input" />
          <Field id="sch-room" label="Ruangan (opsional)" placeholder="mis. R.1A" value={f.room} onChange={(e) => setF({ ...f, room: e.target.value })} data-testid="schedule-room-input" />
        </FormCard>
      )}
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-muted-foreground">Guru hanya dapat dijadwalkan pada mata pelajaran yang menjadi penugasan aktifnya. Slot yang bertabrakan ditolak.</p>
        <div className="w-48">
          <Pick label="Filter kelas" value={kelas} onChange={setKelas}
            options={[{ value: "semua", label: "Semua kelas" }, ...(classes.data || []).map((k) => ({ value: k.id, label: k.name }))]} testId="schedule-class-filter" />
        </div>
      </div>
      <ListState q={q} empty={{ title: "Belum ada jadwal pelajaran", description: canManage ? "Tambahkan slot jadwal pertama menggunakan formulir di atas." : "Admin sekolah akan mengisi jadwal pelajaran." }}>
        {(rows) => (
          <div className="space-y-5">
            {HARI.map((h) => {
              const slots = rows.filter((r) => r.day_of_week === h);
              if (!slots.length) return null;
              return (
                <section key={h} data-testid={`schedule-day-${h}`}>
                  <h3 className="font-bold mb-2">{h}</h3>
                  <ul className="divide-y rounded-2xl border bg-card">
                    {slots.map((r) => (
                      <li key={r.id} className="flex flex-wrap items-center justify-between gap-2 p-4" data-testid={`schedule-${r.id}`}>
                        <p className="text-sm">
                          <span className="font-mono font-semibold">{r.start_time}–{r.end_time}</span>
                          {" · "}<b>{r.subject_name}</b> · {r.class_name} · {r.teacher_name}
                          {r.room ? ` · ${r.room}` : ""}
                        </p>
                        {canManage && <Button size="sm" variant="outline" onClick={() => hapus(r)} data-testid={`schedule-delete-${r.id}`}>Hapus</Button>}
                      </li>
                    ))}
                  </ul>
                </section>
              );
            })}
          </div>
        )}
      </ListState>
    </div>
  );
};
